"use strict";

var color = require("color-js");

// Transform "red" to "#FF0000" then removes the "#"
module.exports = function (value) {
  var col = color(value);
  if (col.alpha === 0) {
    // Fully transparent is no color
    return null;
  }
  return col.toCSSHex().substring(1);
};